export const config = {
    menu: {
        full: [
            {
                key: "home",
                icon: "home-line",
                label: "common.labels.home",
                url: `/home`,
            },
            {
                key: "members",
                icon: "d-pad",
                label: "common.labels.members",
                url: "/members",
            },
            {
                key: "collection",
                icon: "books",
                label: "common.labels.collections",
                url: `/collection`,
            },
            {
                key: "register",
                icon: "add-form",
                label: "common.labels.registrations",
                url: `/register`,
            },
            // {
            //     key: "finances",
            //     icon: "finances",
            //     label: "common.labels.finances",
            //     url: "/finances",
            // },
            // {
            //     key: "settings",
            //     icon: "settings",
            //     label: "common.labels.settings",
            //     url: "/config",
            // },
        ],
        collection: [
            {
                key: "console",
                icon: "gamepad",
                label: "collection.labels.consoles",
                url: `/collection/console`,
            },
            {
                key: "game",
                icon: "no-image",
                label: "collection.labels.games",
                url: `/collection/game`,
            },
            {
                key: "accessorie",
                icon: "no-image",
                label: "collection.labels.accessories",
                url: `/collection/accessorie`,
            },
        ],
        register: [
            {
                key: "podcast",
                icon: "no-image",
                label: "podcast.labels.podcasts",
                url: `/register/podcast`,
            },
            // {
            //     key: "platform",
            //     icon: "platform",
            //     label: "platform.labels.platforms",
            //     url: `/register/platform`,
            // },
            {
                key: "manufacturer",
                icon: "no-image",
                label: "common.labels.manufacturers",
                url: `/register/manufacturer`,
            },
            {
                key: "region",
                icon: "no-image",
                label: "region.labels.regions",
                url: `/register/region`,
            },
            {
                key: "language",
                icon: "no-image",
                label: "common.labels.languages",
                url: `/register/language`,
            },
            {
                key: "media",
                icon: "no-image",
                label: "media.labels.medias",
                url: `/register/media`,
            },
            {
                key: "franchise",
                icon: "no-image",
                label: "franchise.labels.franchises",
                url: `/register/franchise`,
            },
            {
                key: "release",
                icon: "no-image",
                label: "release.labels.releases",
                url: `/register/release`,
            },
            {
                key: "gender",
                icon: "no-image",
                label: "gender.labels.genders",
                url: `/register/gender`,
            },
            {
                key: "tag",
                icon: "no-image",
                label: "tag.labels.tags",
                url: `/register/tag`,
            },
            {
                key: "users",
                icon: "group",
                label: "common.labels.users",
                url: `/register/user`,
            },
            // {
            //     key: "plans",
            //     icon: "plans",
            //     label: "common.labels.plans",
            //     url: `/register/plan`,
            // },
            // {
            //     key: "services",
            //     icon: "services",
            //     label: "common.labels.services",
            //     url: `/register/service`,
            // },
            // {
            //     key: "position",
            //     icon: "bag",
            //     label: "common.labels.positions",
            //     url: `/register/position`,
            // },
            // {
            //     key: "qualification",
            //     icon: "services",
            //     label: "common.labels.qualifications",
            //     url: `/register/qualification`,
            // },
            // {
            //     key: "skill",
            //     icon: "skill",
            //     label: "common.labels.skills",
            //     url: `/register/skill`,
            // },
        ],
    },
}